export default __webpack_public_path__ + "9ade5d3a37680e68d9e1c9ee7f185d4a.png";